var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames"
          }
        },
        [
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.deletingRoom,
                  expression: "deletingRoom"
                }
              ],
              attrs: { title: "Οι Συνομιλίες μου", name: "1" }
            },
            [
              _c("div", [
                _vm._v(
                  "Μπορείτε να διαγράψετε τις παρακάτω συνομιλίες ή να αποχωρήσετε από αυτές"
                )
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.privateChats }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "label", label: "Όνομα", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(scope.row.label))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    staticStyle: { width: "60%" },
                    attrs: { prop: "members", label: "Συμμετέχοντες" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.users
                                      .map(function(user) {
                                        return user.name
                                      })
                                      .join(", ")
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "Ενέργειες", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.isChatAdmin(scope.row)
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Διαγραφή Συνομιλίας",
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.roomDelete(scope.row.id)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Αποχώρηση από Συνομιλία",
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-remove"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.removeMe(scope.row.id)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "Ανοιχτές Συνομιλίες", name: "2" } },
            [
              _c("div", [
                _vm._v("Δημόσιες συνομιλίες που μπορείτε να συμμετέχετε")
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.publicChats }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "label", label: "Όνομα", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(scope.row.label))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    staticStyle: { width: "60%" },
                    attrs: { prop: "members", label: "Συμμετέχοντες" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.users
                                      .map(function(user) {
                                        return user.name
                                      })
                                      .join(", ")
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "Ενέργειες", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.isChatAdmin(scope.row)
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Διαγραφή Συνομιλίας",
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.roomDelete(scope.row.id)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.inMyPublicChats(scope.row)
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "Αποχώρηση από Συνομιλία",
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-remove"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.removeMe(scope.row.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: "Εγγραφή στη Συνομιλία",
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-circle-plus"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.addMe(scope.row.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-collapse-item",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.creatingChatRoom,
                  expression: "creatingChatRoom"
                }
              ],
              attrs: { title: "Νέα Συνομιλία - Προσθήκη Χρηστών", name: "3" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "180px", inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Επιλέξτε Συνομιλία" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "Νέα",
                          "inactive-text": "Υπάρχουσα"
                        },
                        on: { change: _vm.newOrExistingChanged },
                        model: {
                          value: _vm.newOrExisting,
                          callback: function($$v) {
                            _vm.newOrExisting = $$v
                          },
                          expression: "newOrExisting"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.newOrExisting
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Όνομα Συνομιλίας" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Όνομα",
                              "suffix-icon": "el-icon-search"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key
                                  )
                                ) {
                                  return null
                                }
                                _vm.createFindRoom($event)
                              }
                            },
                            model: {
                              value: _vm.roomName,
                              callback: function($$v) {
                                _vm.roomName = $$v
                              },
                              expression: "roomName"
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.private,
                                callback: function($$v) {
                                  _vm.private = $$v
                                },
                                expression: "private"
                              }
                            },
                            [_vm._v("Ιδιωτική Συνομιλία")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.newOrExisting
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Όνομα Συνομιλίας" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Συνομιλίες",
                                filterable: "filterable"
                              },
                              on: { change: _vm.existingRoomSelected },
                              model: {
                                value: _vm.roomName,
                                callback: function($$v) {
                                  _vm.roomName = $$v
                                },
                                expression: "roomName"
                              }
                            },
                            _vm._l(_vm.myAdminChats, function(chat) {
                              return _c("el-option", {
                                key: chat.id,
                                attrs: { label: chat.label, value: chat.id }
                              })
                            })
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createFindRoom }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.newOrExisting ? "Δημιουργία" : "Εύρεση")
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectChatUsers,
                      expression: "selectChatUsers"
                    }
                  ]
                },
                [
                  _vm._v("Προσθήκη-Αφαίρεση Χρηστών"),
                  _c("el-transfer", {
                    attrs: {
                      filterable: "",
                      "filter-method": _vm.filterMethod,
                      "filter-placeholder": "Φίλτρο για Χρήστες",
                      titles: ["Διαθέσιμοι Χρήστες", "Μέλη Συνομιλίας"],
                      data: _vm.users
                    },
                    on: { change: _vm.modifiedUsers },
                    model: {
                      value: _vm.usersToAdd,
                      callback: function($$v) {
                        _vm.usersToAdd = $$v
                      },
                      expression: "usersToAdd"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "Avatar", name: "4" } },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "180px", inline: true } },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.savingAvatar,
                          expression: "savingAvatar"
                        }
                      ],
                      attrs: { label: "Επιλέξτε Avatar" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Avatar",
                            filterable: "filterable"
                          },
                          on: { change: _vm.existingAvatarSelected },
                          model: {
                            value: _vm.avatarSelected,
                            callback: function($$v) {
                              _vm.avatarSelected = $$v
                            },
                            expression: "avatarSelected"
                          }
                        },
                        _vm._l(_vm.avatars, function(avatar) {
                          return _c("el-option", {
                            key: avatar.id,
                            attrs: { label: avatar.label, value: avatar.label }
                          })
                        })
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveAvatar }
                        },
                        [_vm._v("Αποθήκευση")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("img", { attrs: { src: _vm.avatarImage, alt: "Avatar" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89bd964a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89bd964a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat/manageChatRoom.vue
// module id = null
// module chunks = 